// Runtime config from Vite env (import.meta.env). No hard-coded prod fallbacks —
// set VITE_* explicitly (the Canvas 3002-vs-8080 default mismatch was a footgun).

const env = import.meta.env as Record<string, string | undefined>;

export const config = {
  apiUrl: env.VITE_API_URL ?? '',
  wsUrl: env.VITE_WS_URL ?? '',
  firebase: {
    apiKey: env.VITE_FIREBASE_API_KEY ?? '',
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN ?? '',
    projectId: env.VITE_FIREBASE_PROJECT_ID ?? '',
    appId: env.VITE_FIREBASE_APP_ID ?? '',
    storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET ?? '',
    messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '',
  },
};

// Warn loudly (dev only) if anything required is missing.
if (import.meta.env.DEV) {
  const missing: string[] = [];
  if (!config.apiUrl) missing.push('VITE_API_URL');
  if (!config.wsUrl) missing.push('VITE_WS_URL');
  if (!config.firebase.apiKey) missing.push('VITE_FIREBASE_API_KEY');
  if (!config.firebase.projectId) missing.push('VITE_FIREBASE_PROJECT_ID');
  if (missing.length) console.warn('[legend] missing env:', missing.join(', '));
}
